import React, { ReactElement } from 'react';

import { makeStyles, createStyles } from '@material-ui/core/styles';
import Button, { ButtonProps } from '@material-ui/core/Button';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      padding: '2px 24px'
    },
    outlinedSecondary: {
      borderRadius: 16,
      borderWidth: 2
    },
    label: {
      textDecoration: 'unset',
      whiteSpace: 'nowrap'
    }
  })
);

const AssignProductsButton = (props: ButtonProps): ReactElement => {
  const classes = useStyles();
  return (
    <Button {...props} variant="outlined" color="primary" disableElevation classes={classes}>
      Assign Products
    </Button>
  );
};

export default AssignProductsButton;
